import { useMultiStepForm } from '$components'

export function CreatePetFormContent() {
  const { getCurrentStep } = useMultiStepForm()

  return (
    <div className="flex flex-col gap-stack-section flex-grow">
      {getCurrentStep().content}
    </div>
  )
}
